module.exports = __webpack_public_path__ + "static/img/GEN-1.3be7fb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GEN-1.jpg
// module id = GRq6
// module chunks = 0